/**
 * FollowUpInput — bottom pane of the Matter AI Workspace.
 *
 * Optional free-text instruction for the action.  Required for the
 * "Ask about this document" and "Draft in precedent style" actions;
 * optional for everything else.
 */
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Play } from "lucide-react";

export default function FollowUpInput({
    instructionText, onChange,
    requiresInstruction, isRunning, canRun, onRun,
}) {
    const placeholder = requiresInstruction
        ? "Required — describe what you want the model to do."
        : "Optional — add a specific instruction or leave blank.";

    return (
        <div className="space-y-2" data-testid="aiworkspace-followup">
            <Textarea
                value={instructionText}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                rows={3}
                className="text-sm"
                data-testid="aiworkspace-instruction-input"
            />
            <div className="flex items-center justify-between">
                <p className="text-xs text-slate-500 italic">
                    {requiresInstruction
                        ? "This action needs an instruction."
                        : "Leave blank to use the action's default behaviour."}
                </p>
                <Button
                    onClick={onRun}
                    disabled={!canRun || isRunning}
                    className="bg-teal hover:bg-teal/90 text-white"
                    data-testid="aiworkspace-run-btn"
                >
                    <Play className="w-4 h-4 mr-1" />
                    {isRunning ? "Running…" : "Run"}
                </Button>
            </div>
        </div>
    );
}
